export enum FormActionType {
    SetFormReloading = "SET_FORM_RELOADING",
}

export interface FormAction {
    type: FormActionType.SetFormReloading;
    payload: { isFormReloading: boolean };
}
